module.exports = __webpack_public_path__ + "img/character_jialong.5008bc94.png";